module.exports = "<div id=\"container\" style=\"margin-top: 60px;\">{{get(\"pageNotFound\")}}</div>"